import { render, staticRenderFns } from "./ProductsGrid.vue?vue&type=template&id=0c42910d&scoped=true&"
import script from "./ProductsGrid.vue?vue&type=script&lang=js&"
export * from "./ProductsGrid.vue?vue&type=script&lang=js&"
import style0 from "./ProductsGrid.vue?vue&type=style&index=0&id=0c42910d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c42910d",
  null
  
)

export default component.exports